import { IGameState } from 'State/Game/IGameState';
import DateHelper from 'Utility/DateHelper';
import { InactivityNotifications } from 'Constants/Notification';
import { FBTrackingEvent } from 'Utility/Tracking/FBTrackingEvent';
import { LocalNotificationKeys } from 'Constants/NotificatonKeys';
import { GameEventName } from 'Utility/GameEvent/GameEventName';
import { emitGameEvent } from 'Utility/GameEvent/EmitGameEvent';
import { scheduleNotification } from 'Utility/SDK/Notification/ScheduleNotification';
import { ILocalNotificationData } from 'Utility/SDK/Notification/ILocalNotificationData';

export function scheduleInactivityNotification(state: IGameState, cheat: boolean = false): void {
    for (const notification of InactivityNotifications) {
        const displayTime = clampDisplayTime(
            DateHelper.now.getTime() + DateHelper.hoursToMilliseconds(notification.inactiveHours)
        );

        scheduleAndEmitEvent({
            title: 'Solitaire Farm Seasons 5',
            body: notification.getBody(),
            displayTime: cheat ? getCheatNotificationTime() : displayTime,
            tag: notification.tag,
            sendEvent: FBTrackingEvent.INACTIVITY_NOTIFICATION_Sent,
            receiveEvent: FBTrackingEvent.INACTIVITY_NOTIFICATION_Received,
            openEvent: FBTrackingEvent.INACTIVITY_NOTIFICATION_Open,
        });
    }
}

export function clampDisplayTime(time: number): number {
    const startDate = DateHelper.getDateFromValue(time);
    startDate.setHours(11);
    startDate.setMinutes(0);
    startDate.setSeconds(0);

    const endDate = DateHelper.getDateFromValue(time);
    endDate.setHours(22);
    endDate.setMinutes(30);
    endDate.setSeconds(0);

    // Check display time is between 22:30 (ten thirty PM) & 11:00 (eleven AM)
    if (time < startDate.getTime() || time > endDate.getTime()) {
        // Set display time to 11am following day
        const followingDay = DateHelper.getDateFromValue(time);
        followingDay.setDate(followingDay.getDate() + 1);
        followingDay.setHours(11, 1, 0, 0);
        return followingDay.getTime();
    }

    return time;
}

function scheduleAndEmitEvent(
    notification: ILocalNotificationData & {
        sendEvent: FBTrackingEvent;
    }
) {
    scheduleNotification(notification);
    emitGameEvent({
        name: GameEventName.LOCAL_NOTIFICATION_SENT,
        eventData: {
            event: notification.sendEvent,
            parameters: { [LocalNotificationKeys.MESSAGE]: notification.body },
        },
    });
}

function getCheatNotificationTime() {
    // 3 seconds from now.
    return DateHelper.now.getTime() + 3 * 1000;
}
